import { useCallback, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useShopifyNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithContext = useCallback((path) => {
    // Get current URL parameters
    const currentParams = new URLSearchParams(location.search);
    const preservedParams = ['shop', 'host', 'embedded', 'id_token', 'session'];
    
    console.log('Current location:', location.pathname, location.search);
    console.log('Navigating to:', path);
    
    const newParams = new URLSearchParams();
    
    // Keep only Shopify-related params
    preservedParams.forEach(param => {
      const value = currentParams.get(param);
      if (value) {
        newParams.set(param, value);
        console.log(`Preserving param ${param}:`, value);
      }
    });
    
    // Also check for params in window object or sessionStorage
    if (!newParams.has('shop')) {
      const shop = window.SHOPIFY_SHOP || sessionStorage.getItem('shopify_shop');
      if (shop) {
        newParams.set('shop', shop);
        console.log('Using shop from storage:', shop);
      }
    }
    
    if (!newParams.has('host')) {
      const host = window.SHOPIFY_HOST || sessionStorage.getItem('shopify_host');
      if (host) {
        newParams.set('host', host);
        console.log('Using host from storage:', host);
      }
    }
    
    if (!newParams.has('embedded')) {
      newParams.set('embedded', '1');
      console.log('Setting embedded to 1');
    }
    
    // Build the new URL with preserved params
    const queryString = newParams.toString();
    const newPath = queryString ? `${path}?${queryString}` : path;
    
    console.log('Final navigation path:', newPath);
    navigate(newPath);
  }, [navigate, location.search, location.pathname]);

  // Auto-fix URLs that are missing Shopify parameters
  useEffect(() => {
    const currentParams = new URLSearchParams(location.search);
    const hasShopifyParams = currentParams.has('shop') && currentParams.has('host');
    
    if (!hasShopifyParams) {
      console.log('🔧 URL missing Shopify params, attempting to fix...');
      
      const shop = window.SHOPIFY_SHOP || sessionStorage.getItem('shopify_shop');
      const host = window.SHOPIFY_HOST || sessionStorage.getItem('shopify_host');
      
      if (shop && host) {
        const newParams = new URLSearchParams(currentParams);
        
        if (!newParams.has('shop')) newParams.set('shop', shop);
        if (!newParams.has('host')) newParams.set('host', host);
        if (!newParams.has('embedded')) newParams.set('embedded', '1');
        
        const newPath = `${location.pathname}?${newParams.toString()}`;
        console.log('🔧 Auto-fixing URL to:', newPath);
        
        // Use replace to avoid adding to history
        navigate(newPath, { replace: true });
      }
    }
  }, [location.pathname, location.search, navigate]);

  return navigateWithContext;
}